/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SWOTTopicCommentPaginationSlice', 'model/SWOTTopicVoteBatchReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SWOTTopicCommentPaginationSlice'), require('./SWOTTopicVoteBatchReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SWOTTopicReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SWOTTopicCommentPaginationSlice, root.ForStractionServiceApi.SWOTTopicVoteBatchReportPaginationSlice);
  }
}(this, function(ApiClient, SWOTTopicCommentPaginationSlice, SWOTTopicVoteBatchReportPaginationSlice) {
  'use strict';




  /**
   * The SWOTTopicReport model module.
   * @module model/SWOTTopicReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SWOTTopicReport</code>.
   * @alias module:model/SWOTTopicReport
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>SWOTTopicReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SWOTTopicReport} obj Optional instance to populate.
   * @return {module:model/SWOTTopicReport} The populated <code>SWOTTopicReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Importance')) {
        obj['Importance'] = ApiClient.convertToType(data['Importance'], 'Number');
      }
      if (data.hasOwnProperty('VoteBatches')) {
        obj['VoteBatches'] = SWOTTopicVoteBatchReportPaginationSlice.constructFromObject(data['VoteBatches']);
      }
      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = SWOTTopicCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('SessionID')) {
        obj['SessionID'] = ApiClient.convertToType(data['SessionID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('AreaID')) {
        obj['AreaID'] = ApiClient.convertToType(data['AreaID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('ExpirationDate')) {
        obj['ExpirationDate'] = ApiClient.convertToType(data['ExpirationDate'], 'Date');
      }
      if (data.hasOwnProperty('Active')) {
        obj['Active'] = ApiClient.convertToType(data['Active'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Number} Importance
   */
  exports.prototype['Importance'] = undefined;
  /**
   * @member {module:model/SWOTTopicVoteBatchReportPaginationSlice} VoteBatches
   */
  exports.prototype['VoteBatches'] = undefined;
  /**
   * @member {module:model/SWOTTopicCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {Integer} SessionID
   * @default 0
   */
  exports.prototype['SessionID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Integer} AreaID
   * @default 0
   */
  exports.prototype['AreaID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Date} ExpirationDate
   */
  exports.prototype['ExpirationDate'] = undefined;
  /**
   * @member {Boolean} Active
   * @default false
   */
  exports.prototype['Active'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


